import { createFileRoute, redirect } from '@tanstack/react-router';

/** Legacy path — Endpoint Agent 운영은 agent-system-admin 으로 통합 */
const AGENT_SYSTEM_ADMIN = '/agent-system-admin/';

export const Route = createFileRoute('/admin/itops-agent')({
  beforeLoad: () => {
    throw redirect({ href: AGENT_SYSTEM_ADMIN });
  },
});
